module.exports = __webpack_public_path__ + "img/scatters.d0e43e92.svg";